import React, { useEffect, useMemo, useState } from 'react'
import { ResultStatus } from '../utils/types'
import { useNavigate } from 'react-router-dom'
import { DIABETES_FACTS, RESULT_DURATION } from '../utils/constants'


export default function Result({ status }: { status: ResultStatus }) {
    const navigate = useNavigate()
    const [step, setStep] = useState(0);

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (step === 1) navigate("/types")
            else setStep(step => step + 1)
        }, RESULT_DURATION)
        return () => {
            timeout && clearTimeout(timeout)
        }
    }, [step])

    const isWin = useMemo(
        () => status === ResultStatus.Win
        , [status])

    return <section className={`result-container`}>
        {step == 0 && <article className='frame-container'>
            {isWin && <div className='win'></div>}
            <img src={`/assets/${isWin ? 'win.png' : 'lose.png'}`} />
        </article>}
        {step == 1 && <article className='message-container'>
            <div className="banner">
                <div className="content"> {DIABETES_FACTS[Math.floor(Math.random() * (DIABETES_FACTS.length )) ]}</div>
            </div>
        </article>}
    </section>
}